export default __webpack_public_path__ + "static/relationship-021b1f68678f0c5a405e7c3346ec86ee.png";